import Header from "@/components/shared/Header";
import React from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import { tracking as data } from "@/constants/dummy";
import Container from "@/components/shared/Container";
import Table from "@/components/shared/Table";
import { useResetPagination } from "@/hooks/useResetPagination";
import { Calendar } from "primereact/calendar";
import { Nullable } from "primereact/ts-helpers";
import { Button } from "primereact/button";
import { trackingColumns } from "@/constants/columns";
import { useNavigate } from "react-router-dom";
import { filterByColumns, filterByStartandEndDate } from "@/utils/filters";
import NewBatch from "./NewBatch";

export default function Tracking() {
  const datePanel = React.useRef<any>(null);
  const navigate = useNavigate();

  const [dates, setDates] = React.useState<Nullable<(Date | null)[]>>(null);
  const [showSearch, toggleSearch] = React.useReducer((state) => !state, false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [history, setHistory] = React.useState<any>([]);
  const [filter, setFilter] = React.useState<string>("");
  const resetPagination = useResetPagination(filter);
  const [showCreate, toggleCreate] = React.useReducer((state) => !state, false);
  const [product, setProduct] = React.useState<any>("");
  const [cte, setCte] = React.useState<any>("Farmer");
  const filteredData = filterByColumns(history, filter, [
    "batch_number",
    "product",
    "status",
  ]);

  const dateFilteredData = dates
    ? filterByStartandEndDate(
        filteredData,
        dates && dates[0],
        dates && dates[1],
        "date"
      )
    : filteredData;

  React.useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setHistory(data);
      setLoading(false);
    }, 500);
  }, []);

  return (
    <div>
      <Header
        title="Tracking"
        onFilter={(e) => datePanel.current.toggle(e)}
        onDownload={() => {}}
        showSearch={showSearch}
        onSearch={toggleSearch}
        extraAction="Create Batch"
        extraActionIcon="pi pi-plus"
        onExtraAction={() => toggleCreate()}
        value={filter}
        onChange={(e: any) => setFilter(e.target.value)}
        onCloseSearch={() => {
          toggleSearch();
          setFilter("");
        }}
        menuComponent={
          <OverlayPanel ref={datePanel}>
            <div className="flex flex-column gap-2">
              <label>Select date range</label>

              <Calendar
                value={dates}
                onChange={(e) => setDates(e.value)}
                selectionMode="range"
                readOnlyInput
              />

              {/* reset filter */}
              <Button
                label="Reset"
                className="p-button-secondary"
                onClick={() => {
                  setDates(null);
                }}
              />
            </div>
          </OverlayPanel>
        }
      />

      <Container loading={loading}>
        <Table
          data={dateFilteredData}
          columns={[
            ...trackingColumns(),
            {
              selector: (row: any) => row.id,
              grow: 1,
              center: true,
              cell: (row: any) => (
                <Button
                  icon="pi pi-eye"
                  className="p-button-text"
                  onClick={() =>
                    navigate(`/admin/tracking/${row.id}`, {
                      state: row,
                    })
                  }
                />
              ),
            },
          ]}
          resetPagination={resetPagination}
          emptyIcon="pi-history"
          emptyMessage="There are no captured traceability process to show at the moment"
        />

        <NewBatch
          show={showCreate}
          onHide={toggleCreate}
          onCreate={() => {
            navigate(`/admin/tracking/forms/${Math.random()}`, {
              state: {
                batch_number: Math.random(),
                product: product,
                cte: cte,
                status: "In Progress",
              },
            });
          }}
          products={[
            {
              name: "Cashew",
            },
            {
              name: "Cocoa",
            },
            {
              name: "Sugarcane",
            },
          ]}
          ctes={[
            {
              name: "Cte 1",
            },
            {
              name: "Cte 2",
            },
          ]}
          product={product}
          cte={cte}
          setProduct={setProduct}
          setCte={setCte}
        />
      </Container>
    </div>
  );
}
